var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{ref:"editable",tag:"component",staticClass:"editable-element",class:{ edited: !_vm.canUpdate },attrs:{"contenteditable":_vm.canEdit},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }